(() => {
  const initRoot = (root) => {
    if (!root || root.dataset.glp4Ready) return;
    root.dataset.glp4Ready = '1';
    const form = root.querySelector('form[action*="/cart/add"]');
    const planInput = form?.querySelector('input[name="selling_plan"]');
    root.querySelectorAll('[data-glp4-purchase]').forEach((radio) => {
      radio.addEventListener('change', () => {
        root.querySelectorAll('.glp4-buy-option').forEach((card) => card.classList.toggle('is-active', card.contains(radio)));
        if (planInput) planInput.value = radio.value === 'subscription' ? (radio.dataset.planId || '') : '';
        const priceBox = root.querySelector('[data-glp4-price]');
        if (priceBox) {
          const cmp = Number(priceBox.dataset.compare || 0);
          const cents = Number(radio.value === 'subscription' ? priceBox.dataset.sub : priceBox.dataset.onetime);
          const fmt = priceBox.dataset.fmt || '${{amount}}';
          const money = (c) => fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
            const v = (c / 100).toFixed(k.indexOf('no_decimals') > -1 ? 0 : 2);
            const parts = v.split('.');
            const sep = k.indexOf('comma_separator') > -1 ? ['.', ','] : [',', '.'];
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep[0]) + (parts[1] ? sep[1] + parts[1] : '');
          });
          const now = priceBox.querySelector('[data-glp4-now]');
          const save = priceBox.querySelector('[data-glp4-save]');
          if (now && cents > 0) now.textContent = money(cents);
          if (save && cmp > cents) save.textContent = 'Save ' + Math.round((cmp - cents) * 100 / cmp) + '%';
        }
      });
    });
    root.querySelectorAll('[data-glp4-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = root.querySelector('input[name="quantity"]');
        if (!input) return;
        const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.glp4Qty));
        input.value = String(next);
      });
    });
    const track = root.querySelector('[data-glp4-track]');
    const bar = root.querySelector('[data-glp4-progress]');
    if (track && bar) {
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const min = 100 / Math.max(track.children.length, 1);
        bar.style.width = (max > 0 ? min + (100 - min) * (track.scrollLeft / max) : 100) + '%';
      };
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  };
  document.querySelectorAll('[data-glp4-section="hero"]').forEach(initRoot);
  document.addEventListener('shopify:section:load', (event) => initRoot(event.target.querySelector('[data-glp4-section="hero"]')));
})();
